// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_ZyN","cls2":"Comments-cls2_Afl Comments-cls1_ZyN"};